/**
 * CZNA-1596 — the capability behind "Hlášení od veřejnosti". mod-czna-users grants it to
 * reviewers and the authority administrator only (REVIEWER_ONLY_PATHS), so the route is not
 * even registered for a cataloguer; who among them sees reports — the NK supervisor of the
 * record's type and the authority administrator (all reports, 1. 11. 2026) — is the backend's
 * decision, read through `GET /error-reports/summary`.
 */
export var ERROR_REPORTS_CAPABILITY = 'czna-authorities.records.error-reports.collection.get';
